import { render } from "./addtemplate.vue?vue&type=template&id=e5da1506&scoped=true"
import script from "./addtemplate.vue?vue&type=script&lang=js"
export * from "./addtemplate.vue?vue&type=script&lang=js"

import "./addtemplate.vue?vue&type=style&index=0&id=e5da1506&scoped=true&lang=css"

import exportComponent from "/Users/zonegoh/Documents/GitHub/levelup/level-up/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e5da1506"]])

export default __exports__